module.exports = __webpack_public_path__ + "img/safe-line.426bdc1b.svg";